exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".search-template[data-v-27d7a10e]{min-height:100px;margin-top:-35px}", ""]);

